// extracted by mini-css-extract-plugin
export default {"root":"ZFfokBn7","img":"M0O_EeeX"};